import React from 'react';
import { Row, Col } from 'react-bootstrap';

function BottomNavBar({ handleBack, submitButtonTitle }) {
    const bottomBarButtonContainer = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row-reverse"

    }
    return ( 
        <div className="bg-secondary p-2 p-md-3 my-5">
            <Row>
                <Col lg={12} style={bottomBarButtonContainer} >
                    <input type="submit" value={submitButtonTitle} className="btn btn-primary mb-0" />
                    {handleBack &&
                        <input type="button" value="BACK" className="btn btn-primary mb-0"
                            onClick={handleBack} />}
                </Col>
            </Row>
        </div>
    );
}

export default BottomNavBar;